export enum AdvisorDivision {
  KF= 'KF',
  GOLD = 'GOLD',
}
